import Vue from 'vue'
import CryptoJS from 'crypto-js'
import { encrypt } from "./encrypt";
import { Message } from 'element-ui';
import axios from 'axios'
let vm = new Vue()


/**
 *
 * @param {请求连接} url
 * @param {请求参数} data
 * @param {请求方法} method
 */
function http (url, data, method = 'post') {
  var appkey = "6bwktuqcilbhkumemc"
  var appSecret = "owba9kydim0tpsu1knvoxbs9h2qebthr";
  var nonce = Math.floor(Math.random() * 999999 + 100000)
  let sign1 = {
    appkey: appkey,
    nonce: nonce,
    timestamp: parseInt(new Date().getTime() / 1000),
  }

  // if (method == 'get') {
  var ddata = data
  for (let i in ddata) {
    sign1[i] = ddata[i]
  }

  var sign2 = objKeySort(sign1)
  var sign3 = ""
  for (let i in sign2) {

    // if(i=='ip' && (url!='/news/achieve_news_detail'&&url!='/news/achieve_news_by_cid')  ){
    //   continue 
    // }
    sign3 += sign2[i]
  }

  // }

  let params = {
    appkey: appkey,
    nonce: nonce,
    timestamp: parseInt(new Date().getTime() / 1000),
    sign: CryptoJS.MD5(sign3 += appSecret).toString().toLocaleUpperCase(),
  }

  for (let i in ddata) {
    params[i] = ddata[i]
  }
  return new Promise(function (resolve, reject) {
  
    vm.$http({
      // url: vm.GLOBAL.API + url,
      url: url,
      method: method,
      params: params,
      // data: formData
    }).then(res => {
  

      if (res.status === 200) {
        if(!res.data.data&&res.data.error_msg){
          console.log(res.data.error_msg,"我是第一个mess");
         /*  Message({ message: res.data.error_msg, type: "error",duration:8000 }); */
        }
        resolve(res.data.data)
      } else {

        reject(res.data)
      }
    })
  })
}

function httpPost (url, data) {
  // console.log(data, 'data');
  var appkey = "6bwktuqcilbhkumemc"
  var appSecret = "owba9kydim0tpsu1knvoxbs9h2qebthr";
  var nonce = Math.floor(Math.random() * 999999 + 100000)
  let sign1 = {
    appkey: appkey,
    nonce: nonce,
    timestamp: parseInt(new Date().getTime() / 1000),
  }
  let fed_file = {}
  data.map((item, index) => {
    // console.log(item.key);
    if (item.key === 'fed_file') {
      fed_file = item.value;
      data.splice(index, 1)
    }
  })
  let temp = {}
  data.forEach(item => {
    // console.log(item);
    temp[item.key] = item.value
  })
  var ddata = temp
  for (let i in ddata) {
    sign1[i] = ddata[i]
  }
  var sign2 = objKeySort(sign1)
  var sign3 = ""
  for (let i in sign2) {
    sign3 += sign2[i]
  }
  let formData = new FormData()
  // for (let i in data) {
  //     formData.append(i, data[i]);
  // }
  formData.append(data[0].key, data[0].value)
  if (data[1]) {
    formData.append(data[1].key, data[1].value)
  }
  let params = [
    {
      key: "appkey",
      value: appkey
    },
    {
      key: "nonce",
      value: nonce
    },
    {
      key: "timestamp",
      value: parseInt(new Date().getTime() / 1000)
    },
    {
      key: "sign",
      value: CryptoJS.MD5(sign3 += appSecret).toString().toLocaleUpperCase()
    },
  ]

  for (let i = 0; i < params.length; i++) {
    formData.append(params[i].key, params[i].value)
  }
  // console.log(fed_file);
  if (fed_file) {
    formData.append('fed_file', fed_file)
  }
  // console.log(formData);
  return new Promise(function (resolve, reject) {
    vm.$http({
      url: url,
      method: "post",
      // params: params,
      data: formData
    }).then(res => {
      if (res.status === 200) {
        resolve(res.data)
      } else {

        reject(res.data)
      }
    })
  })
}

/**
 *
 * @param {不需要签名或者自定义签名} isno

 */


function httpPosts (url, data,isno=false) {
  return new Promise(function (resolve, reject) {
    if(isno){
      data.signField =data.signField||[]
  }else{
      data.signField = Object.keys(data);
  }

    vm.$http({
      url: url,
      method: "post",
      // params: params,
      data: encrypt(data)
    }).then(res => {
      if (res.status == 200) {
        resolve(res.data)
      } else {
        reject(res.data)
      }
    })
  })
}

function httpPostjj (url, data) {
  var appkey = "mdi5c90nmp6xwpqw56"
  var appSecret = "80aa969f2468ffd4cd13799bdcf80619";
  var nonce = Math.floor(Math.random() * 999999 + 100000)
  let sign1 = {
    appkey: appkey,
    nonce: nonce,
    timestamp: parseInt(new Date().getTime() / 1000),
  }

  let temp = {}
  data.forEach(item => {
    temp[item.key] = item.value
  })
  var ddata = temp
  for (let i in ddata) {
    sign1[i] = ddata[i]
  }
  var sign2 = objKeySort(sign1)
  var sign3 = ""
  for (let i in sign2) {
    sign3 += sign2[i]
  }
  let formData = new FormData()
  // for (let i in data) {
  //     formData.append(i, data[i]);
  // }
  formData.append(data[0].key, data[0].value)
  formData.append(data[1].key, data[1].value)
  let params = [
    {
      key: "appkey",
      value: appkey
    },
    {
      key: "nonce",
      value: nonce
    },
    {
      key: "timestamp",
      value: parseInt(new Date().getTime() / 1000)
    },
    {
      key: "sign",
      value: CryptoJS.MD5(sign3 += appSecret).toString().toLocaleUpperCase()
    },
  ]

  for (let i = 0; i < params.length; i++) {
    formData.append(params[i].key, params[i].value)
  }
  return new Promise(function (resolve, reject) {
    vm.$http({
      url: url,
      method: "post",
      // params: params,
      data: formData
    }).then(res => {
      if (res.status === 200) {
        resolve(res.data)
      } else {

        reject(res.data)
      }
    })
  })
}
function objKeySort (obj) {//排序的函数
  var newkey = Object.keys(obj).sort();
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newObj = {};//创建一个新的对象，用于存放排好序的键值对
  for (var i = 0; i < newkey.length; i++) {//遍历newkey数组
    newObj[newkey[i]] = obj[newkey[i]];//向新创建的对象中按照排好的顺序依次增加键值对
  }
  return newObj;//返回排好序的新对象
}
/**
* 带文件请求
* @param {*} url
* @param {其他参数} data
* @param {要上传的文件} files
* @param {*} method
*/
function uploadFile (url, data, files = [], showMsg = true, method = 'post') {
  let formData = new FormData();
  formData.append("reqParam", JSON.stringify(data));
  files.forEach((item, index) => {
    formData.append("files" + index, item.file);
  });

  const loading = vm.$loading({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)"
  });
  return new Promise((resolve, reject) => {
    vm.$http({
      url: vm.GLOBAL.API + url,
      method: method,
      data: formData
    })
      .then(res => {
        if (res.data.retCode === 1) {
          resolve(res.data.retVal)
        } else {
          if (showMsg) {
            console.log(res.data.error_msg,"我是第二个mess");
            vm.$message.error(res.data.retMsg)
          }
          reject(res.data)
        }
        loading.close();

      })
      .catch(() => {
        loading.close();
      });
  })

}
// 深层拷贝
function deepClone (obj) {
  let type = Object.prototype.toString.call(obj); //通过原型对象获取对象类型
  let newObj;
  if (type === '[object Array]') {
    //数组
    newObj = [];
    if (obj.length > 0) {
      for (let x = 0; x < obj.length; x++) {
        newObj.push(deepClone(obj[x]));
      }
    }
  } else if (type === '[object Object]') {
    //对象
    newObj = {};
    for (let x in obj) {
      newObj[x] = deepClone(obj[x]);
    }
  } else {
    //基本类型和方法可以直接赋值
    newObj = obj;
  }
  return newObj;
}
export default {
  http,
  httpPost,
  httpPosts,
  httpPostjj,
  uploadFile,
  objKeySort
}



// WEBPACK FOOTER //
// ./src/assets/js/method.js